import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = ({ websiteType }) => {
  const getFooterContent = () => {
    switch (websiteType) {
      case 'customer':
        return {
          title: 'ZepEat',
          description: 'Delicious food delivered to your doorstep',
          links: [
            { label: 'About Us', href: '/about' },
            { label: 'Contact', href: '/contact' },
            { label: 'Privacy Policy', href: '/privacy' },
            { label: 'Terms of Service', href: '/terms' }
          ]
        };
      case 'vendor':
        return {
          title: 'Vendor Management',
          description: 'Manage your restaurant operations efficiently',
          links: [
            { label: 'Support', href: '/support' },
            { label: 'Documentation', href: '/docs' },
            { label: 'API', href: '/api' }
          ]
        };
      case 'rider':
        return {
          title: 'Rider Delivery',
          description: 'Fast and reliable food delivery service',
          links: [
            { label: 'Support', href: '/support' },
            { label: 'Safety', href: '/safety' },
            { label: 'Earnings', href: '/earnings' }
          ]
        };
      default:
        return {
          title: 'ZepEat',
          description: 'Connecting customers, vendors, and riders',
          links: []
        };
    }
  };

  const footerContent = getFooterContent();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">{footerContent.title}</h3>
            <p className="footer-description">{footerContent.description}</p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-links-title">Quick Links</h4>
            <ul className="footer-links">
              {footerContent.links.map((link, index) => (
                <li key={index}>
                  <Link to={link.href} className="footer-link">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-social-title">Follow Us</h4>
            <div className="footer-social">
              <a href="#" className="social-link" aria-label="Facebook">📘</a>
              <a href="#" className="social-link" aria-label="Twitter">🐦</a>
              <a href="#" className="social-link" aria-label="Instagram">📷</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2024 {footerContent.title}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
